import React, {Component, Fragment} from 'react'

import Error from 'lib/struct/Error'

import styles from './InputText.less'

class InputText extends Component {
    render() {
        const {className, errorClassName, blockClassName, inputRef, error, ...props} = this.props
        const {
            'block': block_class,
            'input-text': input_class,
            'input-text_invalid': invalid_input_class,
        } = styles
        const input_classes = [input_class]
        const block_classes = [block_class]

        if (className) {
            input_classes.push(className)
        }

        if (blockClassName) {
            block_classes.push(blockClassName)
        }

        if (error) {
            input_classes.push(invalid_input_class)
        }

        return (
            <Fragment>
                <input ref={inputRef} className={input_classes.join(' ')} {...props} />
                <Error className={errorClassName} error={error}/>
            </Fragment>
        )
    }
}

export default InputText